import {
	DEFAULT_BADGE_COLOR,
	DEFAULT_BADGE_SHAPE,
	DEFAULT_BADGE_SIZE,
	normalizeBadgeAttributes,
} from "../extensions/mintlify/badge-html"
import { writeMdxAttribute } from "../extensions/mintlify/icon-html"

interface TurndownLike {
	addRule: (
		key: string,
		rule: {
			filter: (node: Node) => boolean
			replacement: (content: string, node: Node) => string
		},
	) => void
}

const isBadge = (node: Node): boolean =>
	node.nodeName === "SPAN" &&
	(node as HTMLElement).getAttribute("data-type") === "badge"

/** Writes a badge as Mintlify's own tag, leaving out every default. */
export function badgeMdx(element: HTMLElement, content: string): string {
	const attributes = normalizeBadgeAttributes({
		color: element.getAttribute("data-color"),
		size: element.getAttribute("data-size"),
		shape: element.getAttribute("data-shape"),
		icon: element.getAttribute("data-icon"),
		stroke: element.getAttribute("data-stroke"),
		disabled: element.getAttribute("data-disabled"),
	})
	const parts = [
		attributes.color !== DEFAULT_BADGE_COLOR
			? writeMdxAttribute("color", attributes.color)
			: "",
		attributes.size !== DEFAULT_BADGE_SIZE
			? writeMdxAttribute("size", attributes.size)
			: "",
		attributes.shape !== DEFAULT_BADGE_SHAPE
			? writeMdxAttribute("shape", attributes.shape)
			: "",
		attributes.icon ? writeMdxAttribute("icon", attributes.icon) : "",
		attributes.stroke ? "stroke" : "",
		attributes.disabled ? "disabled" : "",
	].filter(Boolean)
	const open = parts.length ? `<Badge ${parts.join(" ")}>` : "<Badge>"
	return `${open}${content.trim()}</Badge>`
}

export function addBadgeMarkdownRules(turndown: TurndownLike): void {
	turndown.addRule("mintlifyBadge", {
		filter: isBadge,
		replacement: (content, node) => badgeMdx(node as HTMLElement, content),
	})
}
